import SegmentedControl from '@components/SegmentedControl/SegmentedControl';
import React, { useCallback } from 'react';
import type { SeasonType } from '../..';
import { useTrackSeasonalToggle } from '../../hooks/useTrackSeasonalToggle';
import Styles from './styles.scss';

interface SeasonalToggleProps {
	selectedSeason: SeasonType;
	onChange: (season: SeasonType) => void;
}

export const SeasonalToggle = ({
	selectedSeason,
	onChange,
}: SeasonalToggleProps) => {
	const trackSeasonalToggle = useTrackSeasonalToggle();

	const options = [
		{ value: 'peak', label: 'Peak season', ariaLabel: 'Peak season pricing' },
		{
			value: 'off-peak',
			label: 'Off-peak season',
			ariaLabel: 'Off-peak season pricing',
		},
	];

	const handleChange = useCallback(
		(value: string) => {
			const season = value as SeasonType;
			trackSeasonalToggle(season);
			onChange(season);
		},
		[onChange, trackSeasonalToggle],
	);

	return (
		<div className={Styles.seasonalToggle}>
			<SegmentedControl
				name="seasonal-pricing"
				options={options}
				selectedValue={selectedSeason}
				onChange={handleChange}
				fixedWidth={true}
				isIndicatorAnimated={true}
				aria-label="Season pricing selection"
				data-testid="seasonal-toggle"
			/>
		</div>
	);
};
